/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Exercise_ActivationInputs */

const en_us2_exercise_activation = /** @type {(inputs: Exercise_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}%`)
};

const pt_br2_exercise_activation = /** @type {(inputs: Exercise_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}%`)
};

const es_419_exercise_activation = /** @type {(inputs: Exercise_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}%`)
};

const pt_pt2_exercise_activation = /** @type {(inputs: Exercise_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}%`)
};

const fr_fr2_exercise_activation = /** @type {(inputs: Exercise_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct} %`)
};

const de_de2_exercise_activation = /** @type {(inputs: Exercise_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}%`)
};

const it_it2_exercise_activation = /** @type {(inputs: Exercise_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}%`)
};

/**
* | output |
* | --- |
* | "{pct}%" |
*
* @param {Exercise_ActivationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_activation = /** @type {((inputs: Exercise_ActivationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_ActivationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_activation(inputs)
	if (locale === "es-419") return es_419_exercise_activation(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_activation(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_activation(inputs)
	if (locale === "de-DE") return de_de2_exercise_activation(inputs)
	if (locale === "it-IT") return it_it2_exercise_activation(inputs)
	return en_us2_exercise_activation(inputs)
});
export { exercise_activation as "exercise.activation" }